import { homepage } from "./../../package.json";

export const NETWORK_ERROR_RETRY_COUNT = 5;
export const NETWORK_ERROR_RETRY_WAIT_MS = 200;
export const SLOW_TIME_THRESHOLD_MS = 10000;
export const FALLBACK_API_SERVER_URL = homepage;
